const backEndService = process.env.API_ROOT
export default {
  backEndService
}



// WEBPACK FOOTER //
// ./src/api/global.js